const ModalEditPhotoMyComp = {
  title: 'Editar el logo de la empresa'
};

export default ModalEditPhotoMyComp;
